module.exports = "https://cdn.hellotech.com/client-assets/electrical-panel-and-charger-distance_e9e839d60dbb678decfff42caa8d77b9.png";